import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const DEFAULT_URL = "";

export const LOGIN_URL = "https://a.ntrk2.com/2e8ecce4-9439-4c70-b00a-a6ad989eed33";
export const REGISTER_URL = "https://a.ntrk2.com/65dca221-8eb3-49fe-9709-2d2a8ac0a940";

export const LOGIN_URL_MAP = {
  "www-gig58.com": "https://a.ntrk2.com/2e8ecce4-9439-4c70-b00a-a6ad989eed33",
  "gig58a.com": "https://a.ntrk2.com/2e8ecce4-9439-4c70-b00a-a6ad989eed33",
  "www-gig58.net": "https://a.ntrk2.com/2e8ecce4-9439-4c70-b00a-a6ad989eed33",
  "gig58a.net": "https://a.ntrk2.com/2e8ecce4-9439-4c70-b00a-a6ad989eed33",
  "gig58th.com": "https://a.ntrk2.com/c4bb6ced-2d22-41c1-b96a-5cd0df42d249",
  "gig5858.com": "https://a.ntrk2.com/c4bb6ced-2d22-41c1-b96a-5cd0df42d249",
};

export const REGISTER_URL_MAP = {
  "www-gig58.com": "https://a.ntrk2.com/65dca221-8eb3-49fe-9709-2d2a8ac0a940",
  "gig58a.com": "https://a.ntrk2.com/65dca221-8eb3-49fe-9709-2d2a8ac0a940",
  "www-gig58.net": "https://a.ntrk2.com/65dca221-8eb3-49fe-9709-2d2a8ac0a940",
  "gig58a.net": "https://a.ntrk2.com/65dca221-8eb3-49fe-9709-2d2a8ac0a940",
  "gig58th.com": "https://a.ntrk2.com/78c32fe4-eb65-468e-a536-12a68bdde15c",
  "gig5858.com": "https://a.ntrk2.com/78c32fe4-eb65-468e-a536-12a68bdde15c",
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const DOWNLOAD_URL = "https://gig58.loadprkw2a.com/download?openExternalBrowser=1&id=lga3bfh73qocmrk";

export * from "./codes";
export * from "./context";
